import { schema } from "normalizr";
import { Board as BoardRecord } from "records/whiteboard";

export const Board = new schema.Entity(
    "boards",
    {},
    {
        // TODO: Temporary for backend returning objects with { board: null, permissions: [...] }
        // probably need to create a 2nd schema
        idAttribute: (value) => value.id || value.board.id,
        processStrategy: (value) => ({
            brand_id: value.brand_id || value.board.brand_id,
            brand_name: value.brand_name || value.board.brand_name,
            created_at_ms: value.created_at_ms || value.board.created_at_ms,
            id: value.id || value.board.id,
            name: value.name || value.board.name,
            pages_ref: value.pages_ref || value.board.pages_ref,
            root_ref: value.root_ref || value.board.root_ref,
        }),
    },
);

(Board as any).record = BoardRecord;
